import React from 'react';

import InfoCard, { InfoCardProps } from './InfoCard';

type InfoSectionProps = {
  sections: InfoCardProps[];
};

export default function InfoSection({ sections }: InfoSectionProps) {
  return (
    <div
      id="info-section"
      className="flex flex-col d:flex-row justify-center d:items-start items-center py-16 border-b border-rp-primary-redesign d:py-0 gap-8 d:gap-24 d:py-20 bg-rp-daylight"
    >
      {sections.map((section) => (
        <InfoCard
          key={section.title}
          imageUrl={section.imageUrl}
          title={section.title}
          content={section.content}
        />
      ))}
    </div>
  );
}
